import { render, staticRenderFns } from "./employee.vue?vue&type=template&id=dfa36bf8&scoped=true&"
import script from "./employee.vue?vue&type=script&lang=js&"
export * from "./employee.vue?vue&type=script&lang=js&"
import style0 from "./employee.css?vue&type=style&index=0&id=dfa36bf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa36bf8",
  null
  
)

export default component.exports